export default __webpack_public_path__ + "static/media/hamburger-menu-img.df94cba7.jpg";